"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRetryInProgress = exports.setApiCallRetrySuccess = exports.setApiCallError = exports.handleError = exports.SET_RETRY_IN_PROGRESS = exports.HANDLE_ERROR = exports.API_CALL_RETRY_SUCCESS = exports.API_CALL_ERROR = void 0;
const HANDLE_ERROR = 'HANDLE_ERROR';
exports.HANDLE_ERROR = HANDLE_ERROR;
const SET_RETRY_IN_PROGRESS = 'SET_RETRY_IN_PROGRESS';
exports.SET_RETRY_IN_PROGRESS = SET_RETRY_IN_PROGRESS;
const API_CALL_ERROR = 'API_CALL_ERROR';
exports.API_CALL_ERROR = API_CALL_ERROR;
const API_CALL_RETRY_SUCCESS = 'API_CALL_RETRY_SUCCESS';
exports.API_CALL_RETRY_SUCCESS = API_CALL_RETRY_SUCCESS;
const handleError = action => ({
  type: HANDLE_ERROR,
  payload: action
});
exports.handleError = handleError;
const setRetryInProgress = isInProgressFlag => ({
  type: SET_RETRY_IN_PROGRESS,
  payload: {
    isInProgress: isInProgressFlag
  }
});
exports.setRetryInProgress = setRetryInProgress;
const setApiCallError = _ref => {
  let {
    errorMessage,
    actionToRetry,
    pageToReturnTo
  } = _ref;
  return {
    type: API_CALL_ERROR,
    payload: {
      errorMessage,
      actionToRetry,
      pageToReturnTo
    }
  };
};
exports.setApiCallError = setApiCallError;
const setApiCallRetrySuccess = page => ({
  type: API_CALL_RETRY_SUCCESS,
  payload: {
    page
  }
});
exports.setApiCallRetrySuccess = setApiCallRetrySuccess;